export const importKeys = {
  all: () => ['imports'] as const,
  list: () => [...importKeys.all(), 'list'] as const,
  detail: (id: string) => [...importKeys.all(), 'detail', id] as const,
}
